/* eslint-disable no-magic-numbers */
import { Link as RouterLink } from 'react-router-dom';
import ConnectImage from '../../../assets/images/connect.png';
import { styled } from '@mui/material/styles';
import {
  Box,
  Card,
  Stack,
  Link,
  Container,
  Typography,
  Button,
} from '@mui/material';
import { PATH_AUTH } from '../../../routes/paths';
import useResponsive from '../../../hooks/useResponsive';
import Page from '../../../components/Page';
import Image from '../../../components/Image';
import { CONNECT_TO_HUBSPOT_API_URL } from 'api/apiConstants';
import AuthHeader from 'components/auth/AuthHeader';
import useAuth from '../../../../src/hooks/useAuth';
import { useTranslation } from 'react-i18next';

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

export const naviagteToHubspot = () => {
  const token = window.localStorage.getItem('accessToken');
  window.location.href = `${CONNECT_TO_HUBSPOT_API_URL}?code=hubspot&bearer=${token}&custom_url=${window.location.protocol}//${window.location.host}/user/portals`;
};

export default function ConnectToHubspot() {
  const { t } = useTranslation();
  const { logout } = useAuth();

  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  return (
    <Page title={t('login')}>
      <RootStyle>
        <AuthHeader>
          {smUp && (
            <Typography variant='body2' sx={{ mt: { md: -2 } }}>
              {t('need_help')}? {''}
              <Link
                variant='subtitle2'
                component={RouterLink}
                to={PATH_AUTH.register}
              >
                {t('support')}
              </Link>
              <Link
                onClick={logout}
                variant='subtitle2'
                color='#2196F3'
                component={RouterLink}
                to=''
              >
                {' | '}
                {t('logout')}
              </Link>
            </Typography>
          )}
        </AuthHeader>

        {mdUp && (
          <SectionStyle>
            <Typography
              variant='h4'
              sx={{
                px: 5,
                mt: 10,
                mb: 5,
                fontSize: '30px',
                fontWeight: 'bold',
              }}
            >
              {t('connect_with_hubspot')}
            </Typography>
            <Image
              sx={{
                width: '50%',
                objectFit: 'contain',
                margin: '0 auto',
              }}
              visibleByDefault
              disabledEffect
              src={ConnectImage}
              alt='login'
            />
          </SectionStyle>
        )}

        <Container maxWidth='sm'>
          <ContentStyle>
            <div
              style={{
                maxWidth: '600px',
                display: 'inline-grid',
                margin: '0 auto',
              }}
            >
              <Stack
                direction='row'
                alignItems='center'
                sx={{ mb: 5, maxWidth: '500px' }}
              >
                <Box sx={{ flexGrow: 1 }}>
                  <Typography
                    gutterBottom
                    sx={{ fontWeight: 'bold', fontSize: '30px' }}
                  >
                    {t('connect_with_hubspot_account')}{' '}
                  </Typography>
                  <Typography
                    sx={{ color: 'text.secondary', fontSize: '14px' }}
                  >
                    {t('connect_with_hubspot')}{' '}
                  </Typography>
                </Box>
              </Stack>
              <Button variant='contained' onClick={naviagteToHubspot}>
                {t('connect_my_hubspot_account')}
              </Button>
              <Button variant='text'>{t('skip_this_step')}</Button>
            </div>
            {!smUp && (
              <Typography variant='body2' align='center' sx={{ mt: 3 }}>
                {t('need_help')}?{' '}
                <Link
                  variant='subtitle2'
                  component={RouterLink}
                  to={PATH_AUTH.register}
                >
                  {t('support')}{' '}
                </Link>
                <Link
                  onClick={logout}
                  variant='subtitle2'
                  color='#2196F3'
                  component={RouterLink}
                  to=''
                >
                  {' | '}
                  {t('logout')}
                </Link>
              </Typography>
            )}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
